import UserError from './UserError.js'

export class GetMessagingChannelContextUserError extends UserError {
  #message

  /**
   * @param {string} message
   * */
  static create({message}) {
    return new GetMessagingChannelContextUserError({message})
  }

  constructor({message}) {
    super()
    this.#message = message
  }

  get message() {
    return this.#message
  }

  toJSON() {
    return {message: this.#message}
  }
}
